// extracted by mini-css-extract-plugin
export default {"summary":"MobileSummary_summary__n3hP4"};